module.exports = __webpack_public_path__ + "static/img/luz.db4e7dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/luz.png
// module id = 0V+U
// module chunks = 1